function getScript(url, callback) {
    $.ajaxSetup({cache: true});
    $.getScript(url)
        .done(function () {
            callback(null, 'OK')
        })
        .fail(function (jqxhr, settings, exception) {
            if (jqxhr.readyState === 0 || !exception) {
                exception = new Error('script ' + url + ' failed to load');
            }
            callback(exception);
        });
}